import React, { Component } from "react";
import PropTypes from "prop-types";
import loadashGet from "lodash.get";

import StoryComponent from "../../MasterTemplate/ComponentPool/StoryComponent";
import VideoComponent from "../../MasterTemplate/ComponentPool/VideoComponent";

class ProductListingBanner extends Component {
  constructor(props) {
    super(props);

    this.state = {
      plbError: false,
    };

    this.onPlbError = this.onPlbError.bind(this);
  }

  onPlbError() {
    this.setState({ plbError: !this.state.plbError });
  }

  get bannerComponent() {
    const { data } = this.props;
    const type = loadashGet(data, "type", null);
    const { plbError } = this.state;
    if (data) {
      switch (type) {
        case "story": {
          if (!plbError) {
            return (
              <StoryComponent.component data={data} onError={this.onPlbError} />
            );
          }
          return null;
        }
        case "youtubeVideo": {
          return (
            <VideoComponent.component
              data={data}
              autoPlay={false}
              modalView={false}
              allowFullScreen={false}
              showTitle={false}
            />
          );
        }
        default: {
          return null;
        }
      }
    }
    return null;
  }

  render() {
    return this.bannerComponent;
  }
}

ProductListingBanner.propTypes = {
  data: PropTypes.shape({}).isRequired,
};

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: ProductListingBanner,
  component: ProductListingBanner,
};

export default ProjectComponent;
